<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="$router.push('/menu')">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <h1 class="page-title">管理者投稿一覧</h1>
        <div v-for="thank in thanks" :key="thank.id" class="post-item">
          <div class="post-meta">
            <span class="post-date">{{ thank.issue_date }}</span>
            <span class="post-author">投稿者：{{ thank.from_name }}</span>
          </div>
          <p class="post-comment">{{ thank.comment }}</p>
          <div class="post-footer">
            <span class="comment-count">
              コメント数:
              <span v-if="thank.comment_count > 0">
                <router-link :to="'/comments/' + thank.id" target="_blank">{{ thank.comment_count }}</router-link>
              </span>
              <span v-else>{{ thank.comment_count }}</span>
            </span>
            <button v-on:click="deleteThanks(thank.id)" class="btn-danger">削除</button>
          </div>
        </div>
        <div v-if="next_exists" class="more-row">
          <button class="btn-secondary" v-on:click="more">さらにみる</button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ThankInfosView",
  data: function() {
    return {
      thanks: [],
      page: 1,
      next_exists: true,
    }
  },
  mounted: function() {
    this.get();
  },
  methods: {
   get: async function() {
     let data = {
       page: this.page,
       max_id: "",
     };
      await axios.get("/thx_info_list", {params: data}).then((response) => {
       if(response.data && response.data.length == 0) {
         this.next_exists = false;
       }
       response.data.forEach(function(x){
         if(x.is_active === true) {
           this.thanks.push(x)
         }
       },this)
     });
   },
  deleteThanks: async function (thank_id) {
    console.log("削除:" + thank_id);
    let data = {
      thx_post_id: thank_id.toString(),
    };
    try {
      const response = await axios.post("/delete_thx_info_post", data);
      if (response.data.status == "OK") {
        let i = 0;
        for (let x = 0; x < this.thanks.length; x++) {
          if (this.thanks[x].id == thank_id) {
            i = x;
            break; // セミコロンを追加
          }
        }
        this.thanks.splice(i, 1);
      }
    } catch (error) {
      console.error("Error deleting thank post:", error);
    }
  },
   more: function() {
     this.page++;
     this.get();
   }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 960px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.10);
  padding: 32px 40px;
}

.page-title {
  font-size: 1.3rem; font-weight: 700;
  color: #1E293B; margin: 0 0 24px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #E2E8F0;
}

.post-item {
  background: #F8FAFC;
  border-radius: 12px;
  border: 1.5px solid #E2E8F0;
  padding: 16px 20px;
  margin-bottom: 12px;
}

.post-meta {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
}

.post-date {
  font-size: 0.8rem;
  color: #64748B;
}

.post-author {
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
}

.post-comment {
  font-size: 0.9rem;
  color: #334155;
  margin: 0 0 12px 0;
  white-space: pre-wrap;
}

.post-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.comment-count {
  font-size: 0.85rem;
  color: #475569;
}

.comment-count a {
  color: #3B82F6;
  text-decoration: none;
  font-weight: 600;
}

.more-row {
  text-align: center;
  margin-top: 20px;
}

.btn-danger {
  padding: 8px 18px; border-radius: 8px; border: none;
  background: #EF4444; color: #fff;
  font-size: 0.85rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s;
}
.btn-danger:hover { background: #DC2626; }

.btn-secondary {
  padding: 10px 24px; border-radius: 8px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; }
</style>
